import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@pharvio/accounts/admin-account/data-access';
import { environment } from '@pharvio/core/shared';

const isInternalApiRequest = (url: string): boolean =>
  [environment.apiUrl].some((apiUrl) => url.startsWith(apiUrl));

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const isAuthRequest = req.url.includes('/auth/tenant/');
  if (isAuthRequest) return next(req);

  const store = inject(Store);
  const tenantId = store.selectSnapshot(AuthState.tenantId);

  if (tenantId && isInternalApiRequest(req.url)) {
    return next(req.clone({ setHeaders: { 'x-tenant-id': tenantId } }));
  }

  return next(req);
};
